function Privacy() {
  return <div>Privacy</div>
}

export default Privacy
